export const loginWidgetContainerSx = {
  width: 514,
  maxWidth: '90vw',
  alignSelf: 'center',
  flex: '1 0 auto',
  display: 'flex',
  flexDirection: 'column',
  '@media (max-width: 514px)': {
    width: 'auto',
  },
};

export const loginWidgetFormSx = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  m: 0,
  '& input:-webkit-autofill': {
    WebkitBoxShadow: '0 0 0 50px transparent inset',
  },
};

export const loginWidgetSubmitSx = {
  mt: '2em',
};

export const loginWidgetForgotSx = {
  mt: 0,
  fontSize: '80%',
  zIndex: 2,
  alignSelf: 'flex-end',
};

export const loginWidgetHrTextSx = {
  width: '100%',
  lineHeight: '1em',
  position: 'relative',
  outline: 0,
  border: 0,
  color: 'black',
  textAlign: 'center',
  height: '1.5em',
  opacity: 0.5,
  '&::before': {
    content: '""',
    background: 'linear-gradient(to right, transparent, #818078, transparent)',
    position: 'absolute',
    left: 0,
    top: '50%',
    width: '100%',
    height: '2px',
  },
  '&::after': {
    content: 'attr(data-content)',
    position: 'relative',
    display: 'inline-block',
    px: '0.5em',
    lineHeight: '1.5em',
    color: '#818078',
    background: '#fff',
  },
};

export const loginWidgetAcceptTermsSx = {
  color: '#b3b3b3',
  fontSize: '0.9rem',
  mt: '3em',
  mb: '1em',
  textAlign: 'center',
  lineHeight: 1.4,
  '& a': {
    color: '#999',
    textDecoration: 'underline',
    '&:hover': {
      color: '#666',
    },
  },
};
